<div class="d-flex justify-content-center mb-2 bg-white mm-alert mm-alert-{{alertType}} {{hiddenClass}}">
    <div class="mm-alert-logo p-2 d-flex flex-column justify-content-center align-items-center">
        <div class="mm-alert-img d-block"></div>
    </div>
    <div class="mm-alert-container d-inline-flex flex-column justify-content-center p-2 py-3">
        <span *ngIf="!messageList?.length && message" class="mm-alert-body whitespace-inherit fs-7">{{ message }}</span>

        <ul *ngIf="messageList?.length" [ngClass]="{'no-bullet': messageList?.length === 1}">
            <li *ngFor="let msg of messageList" class="mm-alert-body whitespace-inherit fs-7">{{ msg }}</li>
        </ul>
        <ng-content></ng-content>
    </div>
</div>
